import React from "react";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

const PatchTooltip = ({ children, ...props }) => (
  <Tooltip {...props}>
    <span>{children}</span>
  </Tooltip>
);

PatchTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PatchTooltip;
